// Code generated by backend/cmd/gen-error-codes. DO NOT EDIT.
// Regenerate with: make gen   (cd backend && go run ./cmd/gen-error-codes ...)
//
// ADR-043 G-2 — every string vocabulary that crosses the API boundary,
// generated from the Go constants (registry: backend/internal/contracts).
// Import these unions instead of writing 'a' | 'b' | 'c' by hand: a value
// that only exists on one side is exactly the drift this file exists to stop
// (the console once carried a 'deleted' file status and a 'same_hash' dedup
// status that no backend ever produced).
//
// Generated at: 2026-11-03T08:17:39Z

/** files.status — uploading → ready | error; corrupted when cloud shards are missing (ADR-022) (Go: internal/files/models.go FileStatus) */
export const FILE_STATUSES = ["uploading", "ready", "error", "corrupted"] as const;
export type FileStatus = (typeof FILE_STATUSES)[number];
export function isFileStatus(v: unknown): v is FileStatus {
  return typeof v === "string" && (FILE_STATUSES as readonly string[]).includes(v);
}

/** dedup_status on POST /files/pre-check and POST /files/upload/init (Go: internal/files/dto.go DedupStatus*) */
export const DEDUP_STATUSES = ["new", "same_name_same_hash", "same_name_diff_hash", "diff_name_same_hash"] as const;
export type DedupStatus = (typeof DEDUP_STATUSES)[number];
export function isDedupStatus(v: unknown): v is DedupStatus {
  return typeof v === "string" && (DEDUP_STATUSES as readonly string[]).includes(v);
}

/** status on GET /files/chunks/:hash/progress — uploading → processing → completed | failed (WORKER-ADR-029 C-6) (Go: internal/files/presigned_upload.go UploadStatus*) */
export const UPLOAD_PROGRESS_STATUSES = ["uploading", "processing", "completed", "failed"] as const;
export type UploadProgressStatus = (typeof UPLOAD_PROGRESS_STATUSES)[number];
export function isUploadProgressStatus(v: unknown): v is UploadProgressStatus {
  return typeof v === "string" && (UPLOAD_PROGRESS_STATUSES as readonly string[]).includes(v);
}

/** files.backup_source (ADR-014); also the ?backup_source= filter on GET /files (Go: internal/files/dto.go BackupSource*) */
export const BACKUP_SOURCES = ["manual", "watcher", "schedule"] as const;
export type BackupSource = (typeof BACKUP_SOURCES)[number];
export function isBackupSource(v: unknown): v is BackupSource {
  return typeof v === "string" && (BACKUP_SOURCES as readonly string[]).includes(v);
}

/** backup_jobs.status — pending → running → success | failed | cancelled (agent transitions in backupjobs.ValidTransition; the server alone may turn success into failed when a file fails at the worker stage afterwards, QA #103) (Go: internal/backup-jobs/model.go JobStatus) */
export const JOB_STATUSES = ["pending", "running", "success", "failed", "cancelled"] as const;
export type JobStatus = (typeof JOB_STATUSES)[number];
export function isJobStatus(v: unknown): v is JobStatus {
  return typeof v === "string" && (JOB_STATUSES as readonly string[]).includes(v);
}

/** job_file_results.status reported by the agent (ADR-045): skip | dedup | reject from files/check, backed_up | failed after upload, backup only from pre-ADR-045 agents (Go: internal/watcher/model.go FileResultStatuses) */
export const JOB_FILE_RESULT_STATUSES = ["skip", "dedup", "backup", "reject", "backed_up", "failed"] as const;
export type JobFileResultStatus = (typeof JOB_FILE_RESULT_STATUSES)[number];
export function isJobFileResultStatus(v: unknown): v is JobFileResultStatus {
  return typeof v === "string" && (JOB_FILE_RESULT_STATUSES as readonly string[]).includes(v);
}

/** backup_destinations.destination_type (Go: internal/backup-destinations/model.go DestinationType) */
export const DESTINATION_TYPES = ["cloud", "on_premise"] as const;
export type DestinationType = (typeof DESTINATION_TYPES)[number];
export function isDestinationType(v: unknown): v is DestinationType {
  return typeof v === "string" && (DESTINATION_TYPES as readonly string[]).includes(v);
}

/** backup_destinations.cloud_provider (Go: internal/backup-destinations/model.go CloudProvider) */
export const CLOUD_PROVIDERS = ["aws", "gcp", "azure"] as const;
export type CloudProvider = (typeof CLOUD_PROVIDERS)[number];
export function isCloudProvider(v: unknown): v is CloudProvider {
  return typeof v === "string" && (CLOUD_PROVIDERS as readonly string[]).includes(v);
}

/** on-premise destination protocol (Go: internal/backup-destinations/model.go Protocol) */
export const PROTOCOLS = ["sftp", "smb"] as const;
export type Protocol = (typeof PROTOCOLS)[number];
export function isProtocol(v: unknown): v is Protocol {
  return typeof v === "string" && (PROTOCOLS as readonly string[]).includes(v);
}

/** on-premise destination auth_type (Go: internal/backup-destinations/model.go AuthType) */
export const AUTH_TYPES = ["password", "key"] as const;
export type AuthType = (typeof AUTH_TYPES)[number];
export function isAuthType(v: unknown): v is AuthType {
  return typeof v === "string" && (AUTH_TYPES as readonly string[]).includes(v);
}

/** storage_pools.type — smart_distribution (the 12 shards spread across the members) | backup (every member holds all 12) (ADR-013; console-managed since ADR-050) (Go: internal/storage-pools/model.go PoolType) */
export const STORAGE_POOL_TYPES = ["smart_distribution", "backup"] as const;
export type StoragePoolType = (typeof STORAGE_POOL_TYPES)[number];
export function isStoragePoolType(v: unknown): v is StoragePoolType {
  return typeof v === "string" && (STORAGE_POOL_TYPES as readonly string[]).includes(v);
}

/** backup_destinations.status (Go: internal/backup-destinations/model.go Status) */
export const DESTINATION_STATUSES = ["not_configured", "healthy", "unhealthy", "verifying"] as const;
export type DestinationStatus = (typeof DESTINATION_STATUSES)[number];
export function isDestinationStatus(v: unknown): v is DestinationStatus {
  return typeof v === "string" && (DESTINATION_STATUSES as readonly string[]).includes(v);
}

/** users.role — the console roles (the watcher principal role is not a user role) (Go: internal/rbac/scope.go Role*) */
export const USER_ROLES = ["admin", "sub_admin", "operator"] as const;
export type UserRole = (typeof USER_ROLES)[number];
export function isUserRole(v: unknown): v is UserRole {
  return typeof v === "string" && (USER_ROLES as readonly string[]).includes(v);
}

/** status on GET /watchers — derived by the backend from last_seen_at + degraded_reason with a 5-minute threshold (ADR-044 D2) (Go: pkg/watcherstatus/status.go Status) */
export const WATCHER_STATUSES = ["online", "degraded", "offline"] as const;
export type WatcherStatus = (typeof WATCHER_STATUSES)[number];
export function isWatcherStatus(v: unknown): v is WatcherStatus {
  return typeof v === "string" && (WATCHER_STATUSES as readonly string[]).includes(v);
}

/** alert_configs.events — every value has a trigger site (ADR-018, ADR-044 D3); anything else is 400 ALERT_EVENT_INVALID (Go: internal/alerts/events.go Event*) */
export const ALERT_EVENTS = ["backup_failed", "schedule_failed", "backup_cancelled", "watcher_offline", "destination_unreachable"] as const;
export type AlertEvent = (typeof ALERT_EVENTS)[number];
export function isAlertEvent(v: unknown): v is AlertEvent {
  return typeof v === "string" && (ALERT_EVENTS as readonly string[]).includes(v);
}

/** restore_requests.kind — all (every file the watcher can see) | files (file_ids) (Go: internal/watcher/restore.go RestoreRequestKind) */
export const RESTORE_REQUEST_KINDS = ["all", "files"] as const;
export type RestoreRequestKind = (typeof RESTORE_REQUEST_KINDS)[number];
export function isRestoreRequestKind(v: unknown): v is RestoreRequestKind {
  return typeof v === "string" && (RESTORE_REQUEST_KINDS as readonly string[]).includes(v);
}

/** restore_requests.status — pending → running → done | failed (watcher.ValidRestoreTransition) (Go: internal/watcher/restore.go RestoreRequestStatus) */
export const RESTORE_REQUEST_STATUSES = ["pending", "running", "done", "failed"] as const;
export type RestoreRequestStatus = (typeof RESTORE_REQUEST_STATUSES)[number];
export function isRestoreRequestStatus(v: unknown): v is RestoreRequestStatus {
  return typeof v === "string" && (RESTORE_REQUEST_STATUSES as readonly string[]).includes(v);
}

/** audit_logs.action — every value has a write site (explicit LogAction or the AuditTrail middleware table, SRS FR-601) (Go: internal/audit-logs/actions.go Action*) */
export const AUDIT_ACTIONS = ["login", "logout", "password_change", "profile_update", "mfa_enable", "mfa_disable", "account_locked", "upload", "download", "restore", "file_delete", "file_restore", "file_purge", "recycle_bin_empty", "error_files_clear", "backup_execute", "backup_cancel", "failed_jobs_clear", "schedule_create", "schedule_update", "schedule_delete", "schedule_trigger", "user_create", "user_update", "user_delete", "user_purge", "user_password_reset", "user_password_setup_email", "user_require_password_change", "account_unlock", "group_create", "group_update", "group_delete", "group_member_add", "group_member_remove", "watcher_create", "watcher_update", "watcher_delete", "watcher_key_regenerate", "restore_request_create", "destination_create", "destination_update", "destination_delete", "destination_test", "alert_config_create", "alert_config_update", "alert_config_delete", "smtp_update", "settings_update", "password_policy_update", "storage_pool_create", "storage_pool_update", "storage_pool_delete", "storage_pool_member_add", "storage_pool_member_remove"] as const;
export type AuditAction = (typeof AUDIT_ACTIONS)[number];
export function isAuditAction(v: unknown): v is AuditAction {
  return typeof v === "string" && (AUDIT_ACTIONS as readonly string[]).includes(v);
}

/** audit_logs.resource_type (Go: internal/audit-logs/actions.go Resource*) */
export const AUDIT_RESOURCE_TYPES = ["session", "user", "group", "file", "backup_job", "schedule", "watcher", "destination", "alert_config", "smtp", "settings", "storage_pool"] as const;
export type AuditResourceType = (typeof AUDIT_RESOURCE_TYPES)[number];
export function isAuditResourceType(v: unknown): v is AuditResourceType {
  return typeof v === "string" && (AUDIT_RESOURCE_TYPES as readonly string[]).includes(v);
}

/** audit_logs.result — success, or failure for a write the server refused / failed (AuditTrail, 401 excluded; QA #99) (Go: internal/audit-logs/actions.go Result*) */
export const AUDIT_RESULTS = ["success", "failure"] as const;
export type AuditResult = (typeof AUDIT_RESULTS)[number];
export function isAuditResult(v: unknown): v is AuditResult {
  return typeof v === "string" && (AUDIT_RESULTS as readonly string[]).includes(v);
}

/** audit_logs.action → the console roles that can produce it (the RequireRole guard of the recording route); the audit page offers a viewer only these (QA #43) (Go: internal/audit-logs/actions.go ActionRoles()) */
export const AUDIT_ACTION_ROLES: Record<AuditAction, readonly UserRole[]> = {
  "login": ["admin", "sub_admin", "operator"],
  "logout": ["admin", "sub_admin", "operator"],
  "password_change": ["admin", "sub_admin", "operator"],
  "profile_update": ["admin", "sub_admin", "operator"],
  "mfa_enable": ["admin", "sub_admin", "operator"],
  "mfa_disable": ["admin", "sub_admin", "operator"],
  "account_locked": ["admin", "sub_admin", "operator"],
  "upload": ["admin", "sub_admin", "operator"],
  "download": ["admin", "sub_admin", "operator"],
  "restore": ["admin", "sub_admin", "operator"],
  "file_delete": ["admin", "sub_admin", "operator"],
  "file_restore": ["admin", "sub_admin", "operator"],
  "file_purge": ["admin", "sub_admin", "operator"],
  "recycle_bin_empty": ["admin", "sub_admin", "operator"],
  "error_files_clear": ["admin", "sub_admin", "operator"],
  "backup_execute": ["admin", "sub_admin"],
  "backup_cancel": ["admin", "sub_admin"],
  "failed_jobs_clear": ["admin", "sub_admin"],
  "schedule_create": ["admin", "sub_admin"],
  "schedule_update": ["admin", "sub_admin"],
  "schedule_delete": ["admin", "sub_admin"],
  "schedule_trigger": ["admin", "sub_admin"],
  "user_create": ["admin", "sub_admin"],
  "user_update": ["admin", "sub_admin"],
  "user_delete": ["admin", "sub_admin"],
  "user_purge": ["admin"],
  "user_password_reset": ["admin", "sub_admin"],
  "user_password_setup_email": ["admin", "sub_admin"],
  "user_require_password_change": ["admin", "sub_admin"],
  "account_unlock": ["admin", "sub_admin"],
  "group_create": ["admin"],
  "group_update": ["admin"],
  "group_delete": ["admin"],
  "group_member_add": ["admin"],
  "group_member_remove": ["admin"],
  "watcher_create": ["admin", "sub_admin"],
  "watcher_update": ["admin", "sub_admin"],
  "watcher_delete": ["admin", "sub_admin"],
  "watcher_key_regenerate": ["admin", "sub_admin"],
  "restore_request_create": ["admin", "sub_admin", "operator"],
  "destination_create": ["admin", "sub_admin"],
  "destination_update": ["admin", "sub_admin"],
  "destination_delete": ["admin", "sub_admin"],
  "destination_test": ["admin", "sub_admin"],
  "alert_config_create": ["admin", "sub_admin"],
  "alert_config_update": ["admin", "sub_admin"],
  "alert_config_delete": ["admin", "sub_admin"],
  "smtp_update": ["admin"],
  "settings_update": ["admin", "sub_admin"],
  "password_policy_update": ["admin"],
  "storage_pool_create": ["admin"],
  "storage_pool_update": ["admin"],
  "storage_pool_delete": ["admin"],
  "storage_pool_member_add": ["admin"],
  "storage_pool_member_remove": ["admin"],
};

